import React from 'react';
import IPSecurity from '../components/IPSecurityManagement';
import ManageSSO from '../components/ManageSSO';
import RolesManagement from '../components/RolesManagement';
import Users from '../components/Users';

export const nestedRoutes = [
  {
    path: 'users',
    component: <Users />,
  },
  {
    path: 'roles',
    component: <RolesManagement />,
  },
  {
    path: 'security',
    component: <IPSecurity />,
  },
  {
    path: 'sso',
    component: <ManageSSO />,
  },
];
